<template>
  <main id="mainCtrl" v-cloak>
    <v-table id="table"
             request-uri="reviews/getList"
             pagesize="50"
             :show-eye="false"
             ref="table">
      <template v-slot:header>
        <v-tr>
          <v-th name="created_at" sort="created_at" width="85">
            Создан
          </v-th>
          <v-th name="ratingCommentLast" sort="ratingCommentLast" width="85">
            Ответ
          </v-th>
          <v-th name="revieweeName" width="300">
            Кому
          </v-th>
          <v-th name="rating" sort="rating" width="90">
            Рейтинг
          </v-th>
          <v-th name="info" minwidth="150">
            Отзыв
          </v-th>
          <v-th name="hasComments" width="70">
            Ответ
          </v-th>
        </v-tr>
        <v-tr>
          <v-th name="created_at" v-slot="{filter}" width="85">
            <date-picker v-model="filter.value"/>
          </v-th>
          <v-th name="ratingCommentLast" v-slot="{filter}" width="85">
            <date-picker v-model="filter.value"/>
          </v-th>
          <v-th name="revieweeName" :debounce="true" v-slot="{filter}" width="300">
            <v-input v-model="filter.value"/>
          </v-th>
          <v-th name="rating" v-slot="{filter}" width="90">
            <v-select
                v-model="filter.value"
                :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "-",
                                    text: "- нет"
                                },
                                {
                                    value: "1",
                                    text: "1 ★☆☆☆☆"
                                },
                                {
                                    value: "2",
                                    text: "2 ★★☆☆☆"
                                },
                                {
                                    value: "3",
                                    text: "3 ★★★☆☆"
                                },
                                {
                                    value: "4",
                                    text: "4 ★★★★☆"
                                },
                                {
                                    value: "5",
                                    text: "5 ★★★★★"
                                }
                            ]'
            ></v-select>
          </v-th>
          <v-th name="info" :debounce="true" v-slot="{filter}">
            <v-input v-model="filter.value"/>
          </v-th>
          <v-th name="hasComments" v-slot="{filter}">
            <v-select
                v-model="filter.value"
                :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "yes",
                                    text: "Есть ответ"
                                },
                                {
                                    value: "no",
                                    text: "Нет ответа"
                                },
                            ]'/>
          </v-th>
        </v-tr>
      </template>
      <template v-slot:row="{ item, index }">
          <v-tr style="cursor: default">
              <v-td colspan="6">
                  <ReviewsPageRow :on-limited="onLimited" :item="item" @update-table="tableUpdate()" :key="item.id"/>
              </v-td>
          </v-tr>
      </template>
    </v-table>
  </main>
</template>

<script>
import {mapState} from "vuex";
import DatePicker from "@base/DatePicker";
import SuggestReviewAnswer from "@mixins/SuggestReviewAnswer"
import ReviewsPageRow from "@common/reviews/ReviewsPageRow";

export default {
  components: {
    'date-picker': DatePicker,
      'ReviewsPageRow':ReviewsPageRow
  },
    mixins: [SuggestReviewAnswer],
    props:{
        onLimited:{default: false},
    },
  data: function () {
    return {
      reviewCommentAuthorTypes: {
        NETWORK: 'Ответ сети',
        CLINIC: 'Ответ клиники',
        DOCTOR: 'Ответ врача',
        PATIENT: 'Ответ пациента'
      },
        M: {
            id: '',
            created_at: '',
            text: '',
        }
    };
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser,
    }),
  },
  methods: {
      tableUpdate(){
          this.$refs.table.update()
      }
  }
}
</script>

<style lang="scss">

</style>
